//*****************************************************************************************************************
//*****************************************************************************************************************
//*************************************(IF YOU HAVE REACHED HERE)**************************************************
//********************************(PLEASE UNDERSTAND THIS PROJECT IS)**********************************************
//****************************************(MADE AND MANAGED BY)****************************************************
//******************************************(KUSHAL VERMA)*********************************************************
//******************************(DON'T TRY TO COPY OR STEAL THIS PROJECT)******************************************
//***********(DO APPRECIATE THE TIME AND EFFORTS THAT I HAVE SPENT IN MAKING THIS PROJECT ALL BY MYSELF)***********
//***************************************(GITHUB: vkushal28)*******************************************************
//****************************(FEEL FREE TO REACH ME OUT FOR ANY QUERIES)******************************************
//**************************(for personal mails : vermakushal.28@gmail.com)****************************************
//*************************(for work related mails : kush.expclick@gmail.com)**************************************
//*****************************************************************************************************************
//*****************************************************************************************************************

import ReactGA from "react-ga";
import React, { useEffect } from "react";
import { Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import FormGroup from "@material-ui/core/FormGroup";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import swal from "sweetalert";

//......keep this import at last......
import { useStyles } from "./Styles";
let formattedTime;
function BookMe() {
  const classes = useStyles();
  const [bookMeForm, setBookMeForm] = React.useState({
    Type: "Booking enquiry",
    Name: "",
    Email: "",
    contactNumber: "",
    eventDate: "",
    bookingFrom: "",
    bookingTill: "",
    message: "",
    latitudeOfUser: "",
    longitudeOfUser: "",
  });
  const handleBooking = () => {
    var sysDate = new Date().toJSON().slice(0, 10);
    if (bookMeForm.eventDate < sysDate) {
      swal("Oops!", "Incorrect date!", "error");
    } else {
      if (
        bookMeForm.Name !== "" &&
        bookMeForm.Email !== "" &&
        bookMeForm.contactNumber !== "" &&
        bookMeForm.eventDate !== "" &&
        bookMeForm.bookingFrom !== "" &&
        bookMeForm.bookingTill !== "" &&
        bookMeForm.message !== "" &&
        bookMeForm.longitudeOfUser !== "" &&
        bookMeForm.latitudeOfUser !== ""
      ) {
        sendFeedback("template_XdTVpsBi", {
          request_type: bookMeForm.Type,
          user_email: bookMeForm.Email,
          user_contactNumber: bookMeForm.contactNumber,
          event_date: bookMeForm.eventDate,
          booking_from: bookMeForm.bookingFrom,
          booking_till: bookMeForm.bookingTill,
          user_message: bookMeForm.message,
          user_latitude: bookMeForm.latitudeOfUser,
          user_longitude: bookMeForm.longitudeOfUser,
          from_name: bookMeForm.Name,
        });
      } else {
        swal(
          "Oops!",
          "Please fill all the details and grant location access",
          "error"
        );
      }
    }
  };

  const sendFeedback = (templateId, variables) => {
    window.emailjs
      .send("gmail", templateId, variables)
      .then((res) => {
        swal("Thank you :)", "Will get back to you soon", "success");
      })
      .catch((err) => swal("Oops!", "Some technical issue occured", "error"));
  };

  useEffect(() => {
    navigator.geolocation.getCurrentPosition((position) =>
      setBookMeForm({
        ...bookMeForm,
        longitudeOfUser: position.coords.longitude,
        latitudeOfUser: position.coords.latitude,
      })
    );
  }, []);

  return (
    <React.Fragment>
      {" "}
      <div
        id="otherComponents"
        className={classes.otherComponents}
        style={{ overflowY: "scroll", overflowX: "hidden" }}
      >
        <div>
          <Typography
            variant="h5"
            color="inherit"
            className=""
            style={{ fontSize: "3.4vw" }}
          >
            Want me to cover your event? <br />
            <Typography variant="caption" color="primary" id="subText">
              Guaranteed reasonable price{" "}
            </Typography>
            <br />
          </Typography>
        </div>
        <div
          style={{
            padding: "14px",
          }}
        >
          <FormGroup className={classes.contactForm}>
            <Grid container spacing={3}>
              <label className={classes.contactMeLabels}>
                What's your/company name?
              </label>
              <Grid item xs={12}>
                <TextField
                  required
                  type="text"
                  id="Name"
                  name="Name"
                  label=""
                  fullWidth
                  autoComplete="name"
                  autoFocus
                  onChange={(event) => {
                    setBookMeForm({
                      ...bookMeForm,
                      [event.target.name]: event.target.value,
                    });
                  }}
                />
              </Grid>
              <label className={classes.contactMeLabels}>
                What's your email ID?
              </label>
              <Grid item xs={12}>
                <TextField
                  required
                  type="email"
                  id="Email"
                  name="Email"
                  label=""
                  fullWidth
                  autoComplete="email"
                  onChange={(event) => {
                    setBookMeForm({
                      ...bookMeForm,
                      [event.target.name]: event.target.value,
                    });
                  }}
                />
              </Grid>
              <label className={classes.contactMeLabels}>
                How may I contact you?
              </label>
              <Grid item xs={12}>
                <TextField
                  required
                  id="contactNumber"
                  name="contactNumber"
                  label="email id or mobile number"
                  fullWidth
                  autoComplete="contactNumber"
                  onChange={(event) => {
                    setBookMeForm({
                      ...bookMeForm,
                      [event.target.name]: event.target.value,
                    });
                  }}
                />
              </Grid>
              <label className={classes.contactMeLabels}>
                What date is event on?
              </label>
              <Grid item xs={12}>
                <TextField
                  required
                  type="date"
                  id="eventDate"
                  name="eventDate"
                  // label="What date is event on?"
                  fullWidth
                  autoComplete="eventDate"
                  onChange={(event) => {
                    setBookMeForm({
                      ...bookMeForm,
                      [event.target.name]: event.target.value,
                    });
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <label className={classes.contactMeLabels}>From</label>
                <TextField
                  required
                  type="time"
                  id="from"
                  name="bookingFrom"
                  fullWidth
                  autoComplete="bookingFrom"
                  onChange={(event) => {
                    setBookMeForm({
                      ...bookMeForm,
                      [event.target.name]: event.target.value,
                    });
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <label className={classes.contactMeLabels}>Till</label>
                <TextField
                  required
                  type="time"
                  id="till"
                  name="bookingTill"
                  fullWidth
                  autoComplete="bookingTill"
                  onChange={(event) => {
                    setBookMeForm({
                      ...bookMeForm,
                      [event.target.name]: event.target.value,
                    });
                  }}
                />
              </Grid>

              <label className={classes.contactMeLabels}>
                Any extra message you want to pass?
              </label>
              <Grid item xs={12}>
                <TextField
                  required
                  multiline
                  type="input"
                  id="message"
                  name="message"
                  label=""
                  fullWidth
                  autoComplete="message"
                  onChange={(event) => {
                    setBookMeForm({
                      ...bookMeForm,
                      [event.target.name]: event.target.value,
                    });
                  }}
                />
              </Grid>
            </Grid>
            <br />
            <Button variant="contained" color="primary" onClick={handleBooking}>
              Book
            </Button>
          </FormGroup>
        </div>
      </div>
      {/* <div className={classes.alertMsg}>
        <Alert severity="success">
          <AlertTitle>Thank you :)</AlertTitle>
          Will get back to you soon!
        </Alert>
      </div> */}
    </React.Fragment>
  );
}
export default BookMe;
ReactGA.event({
  category: "Book me",
  action: "Book me clicked",
});
